export default "__VITE_ASSET__C4sr49aM__"